import React from 'react'
import { useNavigate } from 'react-router-dom'
import { addMilliseconds } from 'date-fns'
import { putCookie, useEffectOnce, useQueryParam } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { Root } from './Callback.styles'

/**
 * The Callback container.
 */
const Callback = () => {
  const navigate = useNavigate()
  const accessToken = useQueryParam('access_token')
  const expiresIn = useQueryParam('expires_in')
  const rut = useQueryParam('rut')

  useEffectOnce(() => {
    // Handle authentication if expected values are in the URL
    if (!accessToken || !expiresIn) throw new Error('Invalid callback URL.')

    const expiresAt = addMilliseconds(new Date(), expiresIn * 1000)

    putCookie('access_token', accessToken, {
      expires: expiresAt
    })

    navigate(`/${rut || ''}`)
  })

  return (
    <Root>
      <Spinner />
    </Root>
  )
}

export default Callback
